/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Parser of translations
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.1.0
 */

export function updateTranslateParams(operatorSettings: object, translation: object) {
    let regExp, curPath, paramPath;
    let translationString = JSON.stringify(translation);
    const parsePropPath = (obj: any, currentPath: string) => {
        for (const i in obj) {
            if (typeof obj[i] === 'object') {
                curPath = currentPath ? currentPath + '.' + i : i;
                parsePropPath(obj[i], curPath);
            } else {
                paramPath = `${currentPath}.${i}`;
                regExp = new RegExp('{' + paramPath + '}', 'g');
                translationString = translationString.replace(regExp, obj[i]);
            }
        }

        regExp = new RegExp('{' + currentPath + '[^}]+}', 'g');
        translationString = translationString.replace(regExp, (param: string) => {
            console.warn('Param not found:', param);
            return '';
        });
    };
    parsePropPath(operatorSettings, 'operatorSettings');
    return JSON.parse(translationString);
}
